import styles from './InputBottomPlaceholder.module.css'
import {Input, InputNumber, InputNumberProps} from "antd";
import {CSSProperties, useState} from "react";
export const InputBottomPlaceholder = ({min=0, max, placeholder,onChangeValue, isDecimal=false, fontSize=32, width=null}:{min?:number,max:number,placeholder:string,onChangeValue:(value:number)=>void,isDecimal?:boolean,fontSize?:number,width?:null|number}) =>{
    const [value,setValue]=useState<number|null>(null)
    const onChange:InputNumberProps['onChange'] = (value)=>{
        if(value==null)return
        setValue(Number(value.toString().replace(",",".")))
        onChangeValue(Number(value.toString().replace(",",".")))
    }

    const propInput:CSSProperties={
        textAlign:"center",
        fontSize:"32px",
        fontWeight:"700"
    }

    const getCSSProp=()=>{
        if(width!=null){
            if(value!=null&&value>1000){
                return {...propInput, width:width,fontSize:fontSize}
            }
        }
        return width==null? propInput:{...propInput, width:width}
        
    }

    return (
        <div className={styles.input_bottom_placeholder_content}>
            {isDecimal&&<InputNumber
                variant={"underlined"}
                style={getCSSProp()}
                onChange={onChange}
                controls={false}
                parser={(num) => num!=undefined?Number(num.toString().replace(',','.')):0}
                min={min}
                max={max}
                placeholder={"0"}
                value={value}/>}
                {!isDecimal&&<InputNumber
                variant={"underlined"}
                style={propInput}
                onChange={onChange}
                step={1}
                controls={false}
                parser={(num) => num!=undefined?Math.round(Number(num)):0}
                min={min}
                max={max}
                placeholder={"0"}
                value={value}/>}
            <div className={styles.input_bottom_placeholder_placeholder}>{placeholder}</div>
        </div>
    )
}